import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { copyMeal, moveMeal } from '../../../api/diary-service';

const useMealCopyOrMove = (actionType) => {
    const [isProcessingAndSyncing, setIsProcessingAndSyncing] = useState(false);
    const queryClient = useQueryClient();

    const isMove = actionType === 'move';
    const mutationFn = isMove ? moveMeal : copyMeal;

    const mutation = useMutation({
        mutationFn,
        onError: (err) => console.error(`Failed to ${isMove ? 'move' : 'copy'} meal:`, err)
    });

    const triggerMealAction = async (payload) => {
        const { from_date, to_date } = payload;

        setIsProcessingAndSyncing(true);

        try {
            await mutation.mutateAsync(payload);

            await Promise.all([
                queryClient.refetchQueries({ queryKey: ['diary', from_date] }),
                queryClient.refetchQueries({ queryKey: ['diary', to_date] }),
                queryClient.refetchQueries({ queryKey: ['energy', 'period'], exact: false })
            ]);

            await queryClient.invalidateQueries({
                queryKey: ['mealDates'],
                exact: false
            });

            return true;
        } catch {
            return false;
        } finally {
            setIsProcessingAndSyncing(false);
        }
    };

    return {
        triggerAction: triggerMealAction,
        isProcessing: isProcessingAndSyncing,
        isError: mutation.isError,
        error: mutation.error,
        reset: mutation.reset
    };
};

export default useMealCopyOrMove;
